import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './north-carolina.model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';
import { RequestService } from '../../../_services/request/request.service';

@Component({
  selector: 'app-north-carolina',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    CommonModule,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './north-carolina.component.html',
})
export class NorthCarolinaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  aboveLiabilityLimit: string = '';

  constructor(
    private requestService: RequestService,
  ) {
    super();
  }

  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('north-carolina', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('north-carolina', null);
    }
  }

  dynamicLimitId: Object = {
    CombinedSingleMinLimit_DropDown: 'combinedsingleminlimit_150k',
    SplitMinLimits_DropDown: 'splitminlimits_50k_100k',
    UMPDMinLimit_DropDown: 'umpdminlimit_50k',
  };

  ngAfterViewInit() {
    let liabilityLimit = this.requestService
      .getLiabilityLimitForState('north-carolina')
      .split('.')[0];
    liabilityLimit = parseFloat(liabilityLimit.replace(/[,$]/g, ''));
    if (liabilityLimit > 1000000) {
      this.aboveLiabilityLimit = "$1M";
    }
  }
}
